import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

export interface IResource {
  id: number
  title?: string
  name?: string
  description: string
  image_url?: string
  difficulty?: string
  dificulty?: string
  [key: string]: any
}

export interface IPlansForAccess {
  id: string
  name: string
  identifier: string
}

export interface IResources {
  id: number
  completed: boolean
  resource_type: string
  resource: IResource | null
  user_has_access: boolean | null
  plans_for_access?: IPlansForAccess[]
  [key: string]: any
}

export interface ISection {
  id: number
  title: string
  sequence: number
  resources: IResources[]
  [key: string]: any
}

export type ResourceKind = 'lesson' | 'challenge' | 'machine';

export const PLANS_URL = 'https://pay.hackingclub.com/plans';

const RESOURCE_KINDS: Record<string, ResourceKind> = {
  'App\\Models\\Lesson': 'lesson',
  'App\\Models\\Challenge': 'challenge',
  'App\\Models\\Machine': 'machine',
};

export const RESOURCE_ICONS: Record<ResourceKind, string> = {
  lesson: 'bi bi-camera-video',
  challenge: 'bi bi-flag',
  machine: 'bi bi-display',
};

const LEVELS = ['easy', 'medium', 'hard', 'insane'];

export const resourceKind = (resource: IResources): ResourceKind =>
  RESOURCE_KINDS[resource.resource_type] || 'lesson';

export const resourceTitle = (resource: IResources): string =>
  resource.resource?.title || resource.resource?.name || '';

export const hasAccess = (resource: IResources): boolean => Boolean(resource.user_has_access);

export const resourceHref = (pathwayId: string | number, resource: IResources): string | null => {
  if (!resource.resource) return null;
  return `/training/learning-paths/${pathwayId}/${resourceKind(resource)}/${resource.resource.id}`;
};

// Máquinas usam "dificulty" e desafios "difficulty" na API
export const resourceLevel = (resource: IResources): string | null => {
  const level = String(resource.resource?.difficulty || resource.resource?.dificulty || '').toLowerCase();
  return LEVELS.includes(level) ? level : null;
};

export const sectionProgress = (section: ISection) => {
  const total = section.resources.length;
  const done = section.resources.filter(resource => resource.completed).length;
  return { done, total, completed: done === total };
};

export const useLearningPathI18n = () => {
  const { t } = useI18n();
  const store = useStore();
  const lang = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage') || 'en');
  const tl = (key: string, params: Record<string, unknown> = {}) => t(`${lang.value}.learning_path_view.${key}`, params);
  return { t, lang, tl };
};
